import React from 'react'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'

function BankAccountNumberDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Institutions.AccountNumber' {...props} />
        <ModalBody>
          <div className='row'>
            <div className='col-12'>
              <FormRow label='Institutions.AccountType' name='accountType' target={props.target} inputType='number' required />
              <FormRow label='Institutions.AccountNumber' name='accountNumber' target={props.target} required inputProps={{ maxLength: 200 }} />
            </div>
          </div>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: BankAccountNumberDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/bankAccountNumber.js